import { Site } from '@envato/foundation-types'
import * as classnames from 'classnames'
import * as React from 'react'
import { RouterAction } from 'react-router-redux'
import get from 'lodash-es/get'

import filterParamsConfig from '../../../common/constants/filterParamsConfig'
import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import { filterSortByOptions } from '../../../common/utils/item'
import { ICommonLocation } from '../../../common/utils/location/types'
import { getConfigBySite } from '../../../config/sites'
import siteDefaultConfigs from '../../../config/sites/defaults'
import Dropdown from '../../components/dropdown'
import ChevronDownIcon from '../../components/icons/chevronDown'
import SortToggleIcon from '../icons/sortToggleIcon'

import * as styles from './sortBy.module.css'

const searchQueryConfigs = siteDefaultConfigs.search_query
const defaultSortByOptions = searchQueryConfigs.default_sort_by_options

interface IProps {
  location: ICommonLocation
  locationParams: ILocationParams
  currentSite: Site
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  experiments: any
  push: (path: string) => RouterAction
}

interface ISortOption {
  value: string
  label: string
}

/**
 * A sort by menu which has lots of business logic
 */
class SortByDropdown extends React.Component<IProps> {
  public render() {
    const { locationParams, currentSite } = this.props

    const sortByOptionsForSegmented = filterSortByOptions(
      currentSite,
      locationParams,
      defaultSortByOptions
    )
    const sortByOptionsForDropdown = this.createSortOptionsForDropdown(
      sortByOptionsForSegmented
    )

    return (
      <div className={styles.sortByWrapper}>
        <div className={styles.sortByDropdown}>
          {this.renderSortOrderDropdown(sortByOptionsForDropdown)}
        </div>

        <div className={styles.sortButtonRow}>
          {sortByOptionsForSegmented.map(this.renderSortOrderButton)}
        </div>
      </div>
    )
  }

  private renderSortOrderDropdown = (options: ISortOption[]) => {
    const currentValue = this.getSelectSortByValue(this.props.locationParams)

    return (
      <React.Fragment>
        <label htmlFor="sortby" className={styles.sortByLabel}>
          Sort by:{' '}
        </label>
        <Dropdown
          id="sortby"
          name="sortby"
          className={styles.sortBySelect}
          options={options}
          onChange={event => this.onSortBySelectionChange(event.target.value)}
          value={currentValue}
        />
        <ChevronDownIcon
          width="22"
          height="14"
          className={styles.chevronIcon}
        />
      </React.Fragment>
    )
  }

  private renderSortOrderButton = (option: ISortOption, index: number) => {
    const currentValue = this.getSelectSortByValue(this.props.locationParams)
    const buttonStyles = classnames(styles.sortButton, {
      [styles.isActive]: option.value === currentValue
    })

    if (Array.isArray(option.value)) {
      const isSelected = option.value.includes(currentValue)
      const nextSelectIndex = Number(currentValue === option.value[0])
      const selectValue = option.value[nextSelectIndex]
      const buttonStyles = classnames(styles.sortButton, {
        [styles.isActive]: isSelected
      })
      const iconStyles = classnames(styles.sortToggleIcon, {
        [styles.reverse]: !!nextSelectIndex,
        [styles.inactive]: !isSelected
      })

      return (
        <button
          key={index}
          className={buttonStyles}
          onClick={() => this.onSortBySelectionChange(selectValue)}
        >
          {option.label}
          <SortToggleIcon className={iconStyles} />
        </button>
      )
    }

    return (
      <button
        key={index}
        className={buttonStyles}
        onClick={() => this.onSortBySelectionChange(option.value)}
      >
        {option.label}
      </button>
    )
  }

  private getSelectSortByValue(parsedLocation: ILocationParams) {
    let sortOrder

    if (parsedLocation.sort_by) {
      sortOrder =
        parsedLocation.sort_by === 'price' && parsedLocation.sort_direction
          ? 'price-' + parsedLocation.sort_direction
          : parsedLocation.sort_by
    } else if (parsedLocation.term) {
      sortOrder = 'relevance'
    } else {
      sortOrder = getConfigBySite(
        this.props.currentSite,
        'search_query.default_sort_by'
      )
    }

    return sortOrder
  }

  private onSortBySelectionChange = (sort: string) => {
    const { push, locationParams, makeSearchLink } = this.props

    const newQuery: ILocationParams = {
      ...locationParams,
      sort
    }
    delete newQuery.sort_by
    delete newQuery.sort_direction

    push(makeSearchLink(newQuery, this.props.currentSite) + '#content')
  }

  private createSortOptionsForDropdown(sortByOptions: ISortOption[]) {
    const dropdownSortOptions: ISortOption[] = []

    sortByOptions.forEach((option: ISortOption) => {
      if (Array.isArray(option.value)) {
        option.value.forEach(value => {
          dropdownSortOptions.push({
            value,
            label: get(
              filterParamsConfig,
              `sort_by.labels.${value}`,
              option.label
            )
          })
        })
      } else {
        dropdownSortOptions.push(option)
      }
    })

    return dropdownSortOptions
  }
}

export const SortByDropdownComponent = SortByDropdown
export default SortByDropdown
